import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MemberSearchData} from "./member-search.data";

@Injectable()
export class MemberSearchModel extends SearchModel<MemberSearchData> {

    constructor(injector: Injector) {
        super(injector, MemberSearchData);
    }

    override getIdentifierField(): string {
        return "memberId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
